import { shallowCompareSortedArr } from 'utilities/array.js';

export type ImageBounds = { southWestCnr: [number, number]; northEastCnr: [number, number] };

export function IsImageBoundsSame(imageBounds1?: ImageBounds, imageBounds2?: ImageBounds): boolean {
  if (shallowCompareSortedArr(imageBounds1?.northEastCnr, imageBounds2?.northEastCnr)) {
    if (shallowCompareSortedArr(imageBounds1?.southWestCnr, imageBounds2?.southWestCnr)) {
      return true;
    }
  }
  return false;
}
